// simple logging abstraction that we can override on server to get SSR logs
// into the standard logging path on server, rather than emitting to console.log
const frontendLog = {
// eslint-disable-next-line no-console
log: console.log.bind(null, '[INFO]'),
  error: console.error.bind(null, '[ERR]'),
  setLogProviders: (logFn: any, errorFn: any) => {
    frontendLog.log = logFn;
    frontendLog.error = errorFn;
  }
};

export default frontendLog;
